import zionPic from "@/public/images/artists/zion.png";
import { Artist } from "@/types/types";

export const zion = {
  id: "215",
  name: "Zion",
  image: zionPic,
  description: `Zion's voice is bright and airy, with a crisp falsetto that effortlessly floats through the mix. It brings a light, emotional touch to both upbeat Afrobeat rhythms and catchy pop hooks, with a clarity that feels fresh and genuine.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fzion-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Unprocessed",
        "Falsetto",
        "Dance",
        "Pop",
        "RnB",
        "Soul",
        "Airy",
        "Afrobeat",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 52,
        high: 73,
      },
      sweetSpot: 65,
    },
  },
} as const satisfies Artist;
